export default __webpack_public_path__ + "svTransLogoEn.6579241562314c96ac63f8d0bf88515e.png";